import { FAILED_CELL_PREFIX } from '../../constants';
import { type QSetSimilarityResultRowArray } from '../../types';

export default function generateRows(
  data: QSetSimilarityResultRowArray[],
  duplicationRate: number,
) {
  return data.map((row, index) => ({
    id: `row-${index}`,
    children: [
      {
        id: `row-cell-header-${index}`,
        align: 'center' as const,
        children: row[0],
      },
      ...row.slice(1).map((cell, cellIndex) => ({
        // NOTED: Do not change id format, because it is used for dynamic styling
        id:
          Number(cell) <= duplicationRate
            ? `cell-${cell}-${index}-${cellIndex}`
            : `${FAILED_CELL_PREFIX}-${index}-${cellIndex}`,
        align: 'center' as const,
        children: typeof cell === 'number' ? cell.toFixed(2) : cell,
      })),
    ],
  }));
}
